import { Label, Ref, RefDate, RefNumber } from "@tblabs/truffle";
import { BasketItemType } from "../../Models/Basket/BasketItemType";
import { Product } from "../../Models/Product/Product";
import { Basket } from "../../Services/Basket/Basket";
import { SaleBasketItem } from "../../Services/Basket/SaleBasketItem";
import { AddToBasketButton } from "./Components/AddToBasketButton";
import { DiscountBox } from "./Components/DiscountBox";
import { SimpleQuantityBox } from "./Components/QuantityBox";
import { SaleSummaryBox } from "./Components/SaleSummaryBox";
import { ActionBox } from "./ActionBox";
import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { RentBasketItem } from "../../Services/Basket/RentBasketItem";
import { DatesRange } from "../../Models/Dates/DatesRange";


export class SaleBox extends ActionBox
{
    constructor(product: Product, basket: Basket, productOptionId: Ref<string>)
    {
        super(basket);

        const quantityInBasket = basket.GetItemBy(BasketItemType.Sale, product.Id)?.Quantity?.value || 1;
        const quantity = new RefNumber(quantityInBasket);

        const saleItem = new SaleBasketItem(basket, product, productOptionId, quantity);

        this.Append(
            new Table([],[
                [
                    new Label("Ilość").Class("product__form-label"),
                    new SimpleQuantityBox(quantity),
                ]
            ]),
            product.ShowDiscounts.value && new DiscountBox(basket, saleItem.FinalPriceBeforeDiscount),
            new SaleSummaryBox(saleItem),
            new AddToBasketButton(() => this.TryAddToBasket(saleItem))
        );
    }
}

export class ServiceBox extends ActionBox
{
    constructor(product: Product, basket: Basket, productOptionId: Ref<string>)
    {
        super(basket);

        //
        // USŁUGA SERWISU MOŻE BYĆ TRAKTOWANA JAK WYNAJEM ALE BEZ KAUCJI
        // USŁUGA POMOCY MOŻE BYĆ TRAKTOWANA JAK SPRZEDAŻ
        //
        const quantity = new RefNumber(1);
        const datesRange = new DatesRange(new RefDate(new Date(0)), new RefDate(new Date(new Date(0))));

        const rentItem = new RentBasketItem(basket, product, productOptionId, quantity, datesRange);
        const saleItem = new SaleBasketItem(basket, product, productOptionId, quantity);

        this.Append(
            product.ShowDiscounts.value && new DiscountBox(basket, rentItem.FinalPriceBeforeDiscount),
            new SaleSummaryBox(saleItem),
            new AddToBasketButton(() => this.TryAddToBasket(product.AddToBasketAs.Is(BasketItemType.Service) ? rentItem : saleItem))
        );
    }
}
